import StackTracey from 'stacktracey';
class StackTrace extends StackTracey {
    // the default clean method doesn't really work in the browser (or maybe just in safari)
    // because the process of trying to get sources uses some node-specific stuff
    clean() {
        return this
            .mergeRepeatedLines()
            .filter(this.isClean.bind(this));
    }
    // accounts for a second @ in the path, which breaks the default regex
    // as of now, it happens with vite's special /@fs/ path, and only in safari
    // fixing callee and file here fixes the metadata derived from them
    extractEntryMetadata(entry) {
        let { callee, file } = entry;
        if (callee.includes('@')) {
            const [real, ...rest] = callee.split('@');
            callee = real;
            file = [...rest, file].join('@');
        }
        entry = Object.assign(entry, { callee, file });
        return super.extractEntryMetadata(entry);
    }
}
function findStackTraceEntries() {
    const stackTrace = new StackTrace();
    return stackTrace.clean().items;
}
function findStackTraceEntry() {
    const file = normalizeStackTraceEntryFile(import.meta.url);
    return findStackTraceEntryByPreviousFile(file);
}
function findStackTraceEntryByNextFile(endsWith) {
    if (!endsWith) {
        return;
    }
    const entries = findStackTraceEntries();
    let previous;
    for (const entry of entries) {
        const file = normalizeStackTraceEntryFile(entry.file);
        if (file?.endsWith(endsWith) || entry.file === endsWith) {
            return previous;
        }
        previous = entry;
    }
    return;
}
function findStackTraceEntryByPreviousFile(endsWith) {
    if (!endsWith) {
        return;
    }
    const entries = findStackTraceEntries();
    let matched = false;
    for (const entry of entries) {
        const file = normalizeStackTraceEntryFile(entry.file);
        if (file?.endsWith(endsWith) || entry.file === endsWith) {
            matched = true;
        }
        else if (matched) {
            return entry;
        }
    }
    return;
}
function normalizeStackTraceEntryFile(file) {
    try {
        return new URL(file).pathname;
    }
    catch {
        return undefined;
    }
}
export { findStackTraceEntries, findStackTraceEntry, findStackTraceEntryByNextFile, findStackTraceEntryByPreviousFile, normalizeStackTraceEntryFile, };
//# sourceMappingURL=stack-trace.js.map